import React from 'react'
import { useRecoilValue } from 'recoil'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import {
  Panel,
  Spinner,
  SpacingVertical,
  SPACING_16,
  SPACING_8,
  SPACING_4,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  ProgressBarSmall,
  TruncateAndTooltip,
  Flex,
  FlexItem,
  Divider,
  DIVIDER_VARIANT_LIGHT
} from 'mailup-web-components'
import BoxThumbnail from './BoxThumbnail'

import { step1State, step4State } from 'Pages/AbTestWizard/recoil/state/abtest'

const BoxMessaggio = ({ item, index, percTest, abTestMessages, message }) => {
  const intl = useIntl()

  function getDescMsg() {
    let ret =
      intl.formatMessage({ id: 'Load.MailupCommon.Id' }) +
      ' ' +
      item.IdMessaggio
    if (item.Note) {
      ret += ' - ' + item.Note
    }
    return ret
  }
  return (
    <>
      {index > 0 && (
        <>
          <SpacingVertical variant={SPACING_16} />
          <Divider variant={DIVIDER_VARIANT_LIGHT} />
          <SpacingVertical variant={SPACING_16} />
        </>
      )}
      <Flex>
        <FlexItem width='90px' justifySelf='flex-start'>
          <BoxThumbnail item={item} />
        </FlexItem>

        <FlexItem
          margin='0 0 0 24px'
          justifySelf='flex-end'
          width='calc(100% - 125px)'
        >
          <SpacingVertical variant={SPACING_4} />
          <Text variant={TEXT_VARIANT_BOLD}>
            <TruncateAndTooltip text={item.Subject} />
          </Text>
          <SpacingVertical variant={SPACING_4} />
          <Text variant={TEXT_VARIANT_LIGHT}>
            <TruncateAndTooltip text={getDescMsg()} />
          </Text>

          <SpacingVertical variant={SPACING_8} />

          <Text variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage({ id: 'Load.MailupCommon.Recipients' })}{' '}
            {message ? intl.formatNumber(message.Queued) : <Spinner />}
          </Text>

          <SpacingVertical variant={SPACING_8} />
          <ProgressBarSmall
            perc={intl.formatNumber(percTest / abTestMessages.length, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 0
            })}
          />
        </FlexItem>
      </Flex>
    </>
  )
}

BoxMessaggio.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  percTest: PropTypes.number,
  abTestMessages: PropTypes.array,
  message: PropTypes.object
}

const BoxMessages = () => {
  const { percTest, abTestMessages } = useRecoilValue(step1State)
  const { abTestMessages: messages } = useRecoilValue(step4State)

  return (
    <>
      <Panel collapsible={false}>
        {abTestMessages.map((e, i) => (
          <BoxMessaggio
            key={e.IdMessaggio}
            item={e}
            index={i}
            percTest={percTest}
            abTestMessages={abTestMessages}
            message={messages.find(f => f.IdMessage === e.IdMessaggio)}
          />
        ))}
      </Panel>
    </>
  )
}

export default BoxMessages
